import {
    calendarGamePath,
    timeFilterSlug,
} from '@app/router/constants/linkConstants';
import { RouteIdentity } from '@app/router/types';

export const LinkRs: RouteIdentity<string> = {
    App: {
        Home: `/${timeFilterSlug}?`,
        Info: '/informacije',
        Wiki: '/wiki/:pageSlug',
        NotFound: '/404',
        NotAuthorized: '/401',
        TermsAndConditions: '/pravila-igre',
        CatchAll: '*',
        IdCardVerificationCaptive: '/verifikacija-identiteta',
        VerifyPhoneCaptive: '/verify-phone',
    },
    Account: {
        Container: '/profil',
        Profile: '', // empty on purpose
        PaymentGatewayStatus: 'static/html/paymentGatewayStatus.html',
        Activate: '/aktiviraj-nalog',
        PasswordRecovery: '/vracanje-lozinke',
        ForgotPassword: '/zaboravljena-lozinka',
        Recovery: '/pamroutesaccountrecovery',
        Register: '/registracija',
        ResendActivationEmail: '/resendactivationemail',
        ContinueRegistration: '/pamregistrationcontinueregistrationpageurl',
        Deposit: 'uplata',
        History: 'istorija/:type?',
        Settings: 'podesavanja',
        Withdrawal: 'isplata',
        DocumentUpload: 'ucitavanje-dokumenta',
        IdentityVerification: 'verifikacija-identiteta',
        IdentityVerificationUploadAdditional: 'ucitavanje-dokumenata',
        ResponsibleGaming: 'odgovorno-igranje',
        DepositLimit: 'odgovorno-igranje/ogranicenje-uplate',
        BettingLimit: 'odgovorno-igranje/ukupno-ogranicenje-kladenja',
        LossLimit: 'odgovorno-igranje/ogranicenje-gubitka',
        SessionLimit: 'odgovorno-igranje/ogranicenje-sesije',
        SelfExclusion: 'odgovorno-igranje/samoiskljucenje',
        TimeOut: 'odgovorno-igranje/pauza',
        AccountClosure: 'odgovorno-igranje/zatvaranje-naloga',
        RealityCheck: '', // not used
        MyMessages: 'moje-poruke',
        ChangePhone: 'promeni-broj-telefona',
        ReferAFriend: 'refer-a-friend',
        HelpAndSupport: 'pomoc-i-podrska',
        ChatPlaceholder: 'chat',
        MySocial: 'moj-supersocial',
        EditMySocial: 'izmeni-supersocial-profil',
        BlockedUsers: 'blokirani-korisnici',
        MyAccount: 'moj-nalog',
        ChangePassword: 'azuriranje-lozinke',
        SettingsBetslip: 'tiket',
        SwitchLanguage: 'promena-jezika',
        SwitchTheme: 'promena-teme',
        LicencePreferences: 'not-used',
        LoginHistory: 'not-used',
        AccountSecurity: 'not-used',
    },
    Sport: {
        OfferEvent: '/offer-event/:eventSlug/',
        PrematchOffer: '/sportske-opklade',
        BetSlip: '/betslip',
        Filter: '/filter',
        Search: '/pretrazi',
        Favourites: '/omiljeni',
        Category: '/sportske-opklade/:sportSlug?/:categorySlug?',
        CategoryPerTime: `/sportske-opklade/:sportSlug?/:categorySlug?/${timeFilterSlug}`,
        SportCompetitions: '/sportske-opklade/:sportSlug/takmicenja',
        Competition: `/sportske-opklade/:sportSlug/:categorySlug/:tournamentSlug/${timeFilterSlug}?`,
        EventRedirect: '/event/:id(\\d+)',
        TournamentRedirect: '/tournament/:id(\\d+)',
        CategoryRedirect: '/category/:id(\\d+)',
        SuperAdvantage: '/super-prednost/:sportSlug?',
        PriceBoost: '/super-bust/:sportSlug?',
        MultiEventBetBuilder: '/multi-bet-builder/:sportSlug?',
        PopularBets: '/popular-bets',
        TopWinners: '/top-tiketi',
        Social: '/sportske-opklade/:sportSlug/social',
    },
    Lottery: {
        Offer: `/loto-opklade/${timeFilterSlug}?`,
    },
    News: {
        Feed: '/vesti',
        Article: '/vesti/:articleSlug',
        Articles: '/clanci',
    },
    Free2Play: {
        BingoBash: '/bingobash',
        SuperSpin: '/superspin',
        FreeGamesInfo: '/besplatne-igre',
        SportCaller: '/superprono',
        SuperMillion: '/supermillion',
        CalendarGame: `/${calendarGamePath}`,
        SuperShot: '/supershot',
        TopManager: '/top-manager',
        FantasticDuels: '/fantasticni-dueli',
    },
    GrowthMarketing: {
        LandingIntro: '/intro',
        PromotionsInfo: '/promocije',
        NewBettingSiteSerbia: '/nova-kladionica-u-srbiji',
    },
    Native: {
        AppsFooter: '/footerframe',
        Wiki: '/nativewiki/:pageSlug',
    },
    BonusAndComms: {
        LpBonus: '/primulbonus*',
        PromotionHub: '/promocije-i-bonusi',
        Notifications: '/obavestenja',
        MarketingConsent: 'saglasnost-za-marketing',
    },
    Loyalty: {
        Supercoins: '/supercoins',
    },
};
